import React, {useEffect,useState} from 'react';
import {suporteDaSessao} from './sessaoUsuario';
import {encerrarAcessoSuporte} from './suporteProfissional';
import './suporteProfissional.css';

export default function FaixaAcessoSuporte() {
  const suporte=suporteDaSessao();
  const [agora,setAgora]=useState(Date.now());const [erro,setErro]=useState('');const [saindo,setSaindo]=useState(false);
  const exp=Number(suporte?.exp||0)*1000;
  useEffect(()=>{
    if (!exp) return;
    let expirando=false;
    const timer=setInterval(()=>{
      setAgora(Date.now());
      if (!expirando && Date.now()>=exp) {expirando=true;encerrarAcessoSuporte(true);}
    },1000);
    return ()=>clearInterval(timer);
  },[exp]);
  if (!suporte) return null;
  const segundos=Math.max(0,Math.ceil((exp-agora)/1000));
  return <div className="mbgp-faixa-suporte no-print" role="status">
    <div><strong>Acesso de suporte — {suporte.usuario_nome||suporte.profissional}</strong><br/>
      {suporte.administrador_nome} · sessão temporária · {Math.floor(segundos/60)}:{String(segundos%60).padStart(2,'0')} restantes.
      <span className="ml-2">Operações nesta aba usam as permissões do usuário acessado e os dados reais.</span>
      {erro && <div role="alert">{erro}</div>}
    </div>
    <button type="button" className="btn btn-dark btn-sm" disabled={saindo} onClick={async()=>{setSaindo(true);setErro('');try{await encerrarAcessoSuporte();}catch(e){setErro(e.message);setSaindo(false);}}}>
      {saindo?'Encerrando...':'Encerrar acesso de suporte'}
    </button>
  </div>;
}
